export const VIDEO_ON_DEMAND_ROUTE = '/classes/player';
export const LIVE_VIDEO_ROUTE = '/player/live';

export const toVideoOnDemandUrl = (classId: string) => `/classes/player/${classId}`;

export const toLiveVideoUrl = (pelotonId: string, classId: string) =>
  `/player/live/${pelotonId}/${classId}`;

export const getIsVideoPagePath = (path: string): boolean => {
  const onDemandRoute = path.startsWith(VIDEO_ON_DEMAND_ROUTE);
  const liveRoute = path.startsWith(LIVE_VIDEO_ROUTE);

  return Boolean(onDemandRoute || liveRoute);
};
